import { theme } from 'antd'

export default function useToken() {
  const { token } = theme.useToken()
  return {
    token,
  }
}
